import { useCallback, useEffect } from 'react';
import _debounce from 'lodash/debounce';

export default function useDebouncedCallback(cb, deps, delay, config = {}) {
  const callback = useCallback(_debounce(cb, delay, config), deps);

  useEffect(() => {
    const lastCallback = callback;

    return () => lastCallback.cancel();
  }, [callback]);

  return callback;
}
